export function refactorWebsiteLink(link: string) {
  return link?.startsWith("www") ? `https://${link}` : `https://www.${link}`;
}
